/**
 * popup open과 popup으로 부터 전달받은 message에 대한 반응은 따로 관리한다
 */

type MessageSubscriber = (data: MessageEvent['data'], sender?: MessageEventSource) => void

type SenderChecker = (sender?: MessageEventSource) => boolean

const messageSubscribers = new Map<string, MessageSubscriber[]>()

const messageFieldNameMap = new Map<string, string>()

/**
 * message sender만 특정하여 모든 메시지 구독하는 subscriber map
 */
const noKeyMessageSubscribers = new Map<SenderChecker, MessageSubscriber>()

const popupMessageCallback = (event: MessageEvent) => {
    const {data} = event

    const keySubscriberIteration = (key: string) => {
        const subscribers = messageSubscribers.get(key)
        if (subscribers) {
            subscribers.forEach((callback) => callback(data, event.source!))
        }
    }

    if (data) {
        const list = [data.from, data.key, data.type, data.event, data.data?.from]
        list.forEach((content) => {
            if (content) {
                keySubscriberIteration(content)
            }
        })
    }

    if (event.source) {
        // sender 메시지 무조건 구독하는 subscriber 있으면 전달
        for (const [checker, subscriber] of noKeyMessageSubscribers) {
            if (checker(event.source)) {
                subscriber(data, event.source)
            }
        }
    }

    // message로  전달받는 data의 field명이 key, type, event 외의 키일때 사용
    for (const [messageKey, fieldName] of messageFieldNameMap) {
        if (data?.[fieldName]) {
            keySubscriberIteration(messageKey)
        }
    }
}

window.addEventListener('message', popupMessageCallback)

window.addEventListener('pagehide', () => {
    window.removeEventListener('message', popupMessageCallback)
})

// @TODO subscribeMessage, unsubscribeMessage로 리네임 예정
export const subscribeMessage = ({
    messageKey,
    subscriber,
    messageKeyFieldName,
}: {
    messageKey: string
    subscriber: MessageSubscriber
    messageKeyFieldName?: string
}) => {
    if (!messageSubscribers.has(messageKey)) {
        messageSubscribers.set(messageKey, [])
    }

    const subscribers = messageSubscribers.get(messageKey)

    if (subscribers) {
        subscribers.push(subscriber)
    }

    if (messageKeyFieldName) {
        messageFieldNameMap.set(messageKey, messageKeyFieldName)
    }
}

export const unsubscribeMessage = ({messageKey, subscriber}: {messageKey: string; subscriber: MessageSubscriber}) => {
    const subscribers = messageSubscribers.get(messageKey)

    if (subscribers) {
        const index = subscribers.findIndex((callback) => callback === subscriber)
        const restSubscribers = [...subscribers.slice(0, index), ...subscribers.slice(index + 1)]

        if (restSubscribers.length) {
            messageSubscribers.set(messageKey, restSubscribers)
        } else {
            messageSubscribers.delete(messageKey)
        }

        if (messageFieldNameMap.get(messageKey)) {
            messageFieldNameMap.delete(messageKey)
        }
    }
}

/**
 * message sender만 특정하여 모든 메시지 구독
 */
export const subscribeNoKeyMessage = ({
    senderChecker,
    subscriber,
}: {
    senderChecker: SenderChecker
    subscriber: MessageSubscriber
}) => {
    noKeyMessageSubscribers.set(senderChecker, subscriber)
}

/**
 * sender 기준으로 구독하는 메시지 구독 종료
 */
export const unsubscribeNoKeyMessage = (senderChecker: SenderChecker) => {
    noKeyMessageSubscribers.delete(senderChecker)
}
